import React from 'react';

import { Icon } from '@picsio/ui';
import { Info } from '@picsio/icons';

import Tooltip from '../../Tooltip/Tooltip';
import s from '../styles.module.scss';

export default function buildComplianceFieldLabel({
  label,
  diff,
  infoTooltip,
}) {
  return (
    <span className={s.complianceFieldLabel}>
      <Tooltip content={diff ? 'Unpublished changes' : null} placement="top">
        <span className={diff ? s.diffDot : undefined}>{label}</span>
      </Tooltip>
      <If condition={infoTooltip}>
        <Tooltip content={infoTooltip} placement="top">
          <span className={s.complianceFieldInfo}>
            <Icon size="sm">
              <Info />
            </Icon>
          </span>
        </Tooltip>
      </If>
    </span>
  );
}
